import { BaseModel } from "./BaseModel";

export class Rule extends BaseModel {
  schema = "/rule";
  constructor(params) {
    return super(params, "/rule");
  }
}
